import { Component } from '@angular/core';

// Services
import { AuthService } from '../../services/auth.service';

// Model
import { UserInfo } from '../../model/free-trial';

@Component({
	selector: 'app-register-user',
	templateUrl: './register-user.component.html',
})
export class RegisterUserComponent {

	fName: string = "";
	lName: string = "";
	email: string = "";
	password: string = "";
	confirmPassword: string = "";

	doneClicked: boolean = false;

	// Toggle to show password or hide it.
	showPassword: boolean = false;
	showPasswordConfirm: boolean = false;

	constructor(
		private authSvc: AuthService
	) { }

	async btnDone(): Promise<{userInfo: UserInfo, signedUp?: boolean}> {
		this.doneClicked = true;

		if (
			this.isInvalidFormInput(this.fName) ||
			this.isInvalidFormInput(this.lName) ||
			this.isInvalidFormInput(this.email) ||
			this.isInvalidFormInput(this.password) ||
			this.isInvalidFormInput(this.confirmPassword) ||
			this.password !== this.confirmPassword ||
			this.password.length < 8
		) {
			return;
		}

		try {
			// Signup user
			let userInfo = await this.authSvc.signUp(this.email, this.password);
			await this.authSvc.loginEmail(this.email, this.password);
			return { userInfo: this.getUserInfo(userInfo.user.uid, false), signedUp: true };
		}
		catch(e) {
			console.log("error btnDone");
			console.log(e.message);
			let errorCode = e.code;
			console.log("errorCode = " + e.code);

			// This block is necessary in case a user who has an unfinished signup AND local browser storage has been wiped
			if (errorCode === 'auth/email-already-in-use') {
				try {
					let res: firebase.auth.UserCredential = await this.authSvc.loginEmail(this.email, this.password);
					return { userInfo: this.getUserInfo(res.user.uid, res.user.emailVerified) };
				}
				catch(e) {
					console.log("loginEmail error");
					console.error(e.message);
					return Promise.reject(e);
				}
			}

			// Otherwise return error;
			return Promise.reject(e);
		}
	}

	// Constructs UserInfo object and returns it
	getUserInfo(uid: string, emailVerified: boolean): UserInfo {
		return new UserInfo(
			this.fName.trim(),
			this.lName.trim(),
			null,
			this.email.trim(),
			uid,
			emailVerified
		)
	}

	// Form Validation
	isInvalidFormInput(propertyValue: any, touched?: boolean): boolean {
		if (!touched && !this.doneClicked)
			return false; 
		if (!!propertyValue)
			return false

		return true;
	}

	// Used by showPassword and showPasswordConfirm
	// Returns the FontAwesome icon to use
	showPasswordClass(field: boolean) {
		if (field)
			return 'fas fa-eye';

		return 'fas fa-eye-slash';
	}

	// Used by showPassword and showPasswordConfirm
	// Return the input.type that the input should use
	getPasswordInputType(field: boolean) {
		if (field) 
			return 'text';

		return 'password'
	}
}
